<template>
    <!-- Only when there is something to choose. With a single candidate the
         backend answers the question on its own, so the entry would be a tap
         that can only ever be answered one way. -->
    <v-list-item v-if="can_change_employees" @click="open">
        <template v-slot:prepend>
            <v-icon> mdi-badge-account-horizontal-outline </v-icon>
        </template>
        <v-list-item-title>
            {{ t("change_employees") }}
        </v-list-item-title>
        <template v-slot:append>
            <!-- How many are ticked, so the menu answers the question without
                 opening the dialog. -->
            <v-chip v-if="selected_employee_ids.length" size="x-small" color="accent"
                variant="tonal">
                {{ selected_employee_ids.length }}
            </v-chip>
        </template>
    </v-list-item>
</template>

<script>
import bus from "/src/utils/event_bus";
import { usePitStoreBasics } from "@/stores/app_common";
import { useSessionStore } from "@/stores/session";
import { mapState } from "pinia";

export default {
    setup() {
        return { ...usePitStoreBasics() }
    },
    computed: {
        ...mapState(useSessionStore, ["can_change_employees", "selected_employee_ids"]),
    },
    methods: {
        open() {
            // The dialog lives in LeftMenu, mounted once: this menu's content is
            // destroyed as soon as it closes.
            bus.emit("events/employees/open_selector")
            this.$emit("close")
        },
    },
};
</script>
